// removed by extract-text-webpack-plugin
module.exports = {"modal":"_2XTd_EaIB7jbLj8mzrgKvg","failModalContentWrapper":"_2kkk2LFOaNqwmC8mos5vI6","titleWrapper":"_52OZjEvLAzFncm-_mJD14","failModalTitle":"_137fXEwQZ1_UYMSnXG1teg","failModalSubTitle":"_2Wcr8RG72YdadJ76hFnddl","failModalButton":"_21XwL0sIm_K3PfgD58Im8G"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/UserAuthenticationPage/ModalError/ModalError.scss
// module id = 1856
// module chunks = 0